import React, { Component } from "react";

import { Row, Col } from "react-flexbox-grid";
import { FormattedNumber } from "react-intl";
import Big from "big.js";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { SaleStatusSemaphore, CurrencyValue, InfoTooltip } from "components/support";

import {
  Page,
  Loadable,
  DataTable,
  ViewSaleButton,
  Fab
} from "components/support";

import { SaleStatus } from "core/enum";

import { colors, Icon } from "assets";
import styles from "./styles";
import Filter from "./filter";
import SummaryCard from "./summary-card";

class ProductSalesReportView extends Component {
  saleConfig = {
    identifier: "sale_id",
    columns: [
      {
        accessor: "id",
        show: false
      },
      {
        accessor: "activated_at",
        type: "datetime",
        align: "center",
        Header: "Data"
      },
      {
        id: "number",
        Header: "Documento",
        Cell: props => (
          <ViewSaleButton
            sale={{
              uuid: props.row._original.sale_uuid,
              document: {
                type: props.row._original.type,
                serie: props.row._original.serie,
                number: props.row._original.number
              }
            }}
          />
        )
      },
      {
        accessor: "status",
        Header: "Status",
        type: "enum",
        align: "center",
        params: { enum: SaleStatus },
        sortable: false,
        Cell: props => (
          <SaleStatusSemaphore
            status={props.row._original.status}
            description={props.row._original.sefaz_description}
            code={props.row._original.sefaz_code}
            type={props.row._original.type}
          />
        )
      },
      {
        id: "revenues_value",
        accessor: ({ revenues_value }) => revenues_value,
        Header: "Faturamento",
        type: "money",
        align: "right"
      },
      {
        id: "costs_value",
        accessor: ({ costs_value }) => costs_value,
        Header: "Custos",
        type: "money",
        align: "right"
      },
      {
        id: "discounts_value",
        accessor: ({ discounts_value }) => discounts_value,
        Header: "Desconto",
        type: "money",
        align: "right"
      },
      {
        accessor: "profit",
        Header: "Lucro Bruto",
        align: "right",
        Cell: props => this.saleProfit(props.row._original)
      }
    ]
  };

  productConfig = {
    identifier: "product_id",
    columns: [
      {
        Header: "Código",
        accessor: "product_code"
      },
      {
        accessor: "product_name",
        Header: "Nome",
        align: "left"
      },
      {
        id: "quantities_value",
        accessor: ({ quantities_value }) =>
          quantities_value ? quantities_value.toString() : 0,
        Header: "Quantidade Vendida",
        align: "right"
      },
      {
        id: "revenues_value",
        type: "money",
        accessor: ({ revenues_value }) => revenues_value,
        Header: "Faturamento",
        align: "right"
      },
      {
        id: "costs_value",
        type: "money",
        accessor: ({ costs_value }) => costs_value,
        Header: (
          <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            Custos
            <InfoTooltip hint="Não são considerados os custos dos opcionais." />
          </span>
        ),
        align: "right"
      },
      {
        id: "discounts_value",
        type: "money",
        accessor: ({ discounts_value }) => discounts_value,
        Header: "Desconto",
        align: "right"
      },
      {
        id: "profit",
        type: "money",
        Header: "Lucro Bruto",
        align: "right",
        accessor: ({ profit }) => profit
      },
      {
        id: "stock_count",
        Header: "Saldo Disponível",
        align: "right",
        accessor: ({ stock_count }) => stock_count
      },
      {
        id: "stock_value",
        Header: "Valor do Estoque",
        align: "right",
        type: "money",
        accessor: ({ stock_value }) => stock_value
      }
    ]
  };

  saleProfit({ revenues_value, profit }) {
    const profitInPercentage =
      revenues_value !== 0 ? profit / revenues_value : 0;
    return (
      <div>
        <CurrencyValue value={profit} type="money" />
        {
          <span style={styles.profitChip}>
            {profit >= 0
              ? Big(profitInPercentage)
                  .times(100)
                  .toFixed(2)
              : `0.00`}
            %
          </span>
        }
      </div>
    );
  }

  productProfit(productSummary) {
    let relativeProfit, absoluteProfit;

    if (productSummary.currentRevenues) {
      relativeProfit = Big(productSummary.profitInPercentage)
        .times(100)
        .toFixed(2);
    } else {
      relativeProfit = 0;
    }

    if (productSummary.currentProfit) {
      absoluteProfit = Big(productSummary.currentProfit).div(100);
    } else {
      absoluteProfit = 0;
    }

    return (
      <div>
        <FormattedNumber value={absoluteProfit} format="BRL" />
        {<span style={styles.profitChip}>{relativeProfit}%</span>}
      </div>
    );
  }

  downloadButton = () => (
    <Fab
      backgroundColor={colors.button.secondary}
      tooltip="Download"
      icon="file_download"
      options={[
        {
          backgroundColor: colors.secondary.light,
          onClick: () => this.props.presenter.onDownload("csv"),
          iconComponent: (
            <Icon.CsvFile style={{ fill: colors.secondary.dark }} />
          ),
          tooltip: "CSV"
        }
        /*
        {
          backgroundColor: colors.primary.normal,
          onClick: () => this.handleDownloadButton('pdf'),
          icon: icons.svg.pdfFile,
          tooltip: 'PDF'
        },
        */
      ]}
    />
  );

  render() {
    const { presenter, viewModel } = this.props;
    const {
      loading,
      filters,
      results,
      pagination,
      order,
      summary,
      userSearchOptions,
      productSearchOptions,
      product,
      user,
      mode
    } = viewModel;

    return (
      <Page>
        <Typography type="display1" className="pb-sm">
          Vendas por Produto
        </Typography>

        <Filter
          loading={loading}
          filters={filters}
          product={product}
          user={user}
          productSearchOptions={productSearchOptions}
          userSearchOptions={userSearchOptions}
          onSelectProduct={product => presenter.onSelectProduct(product)}
          onSelectUser={user => presenter.onSelectUser(user)}
          onChange={filters => presenter.onFilterChange(filters)}
        />

        <Row>
          <Col xs={12} md>
            <SummaryCard
              loading={loading}
              value={summary.revenues}
              label="Faturamento Total"
              tooltip="Inclui faturamento dos opcionais."
            />
          </Col>

          <Col xs={12} md>
            <SummaryCard
              loading={loading}
              value={summary.costs}
              label="Custos"
              tooltip="Não são considerados os custos dos opcionais."
            />
          </Col>

          <Col xs={12} md>
            <SummaryCard
              loading={loading}
              revenues={summary.revenues}
              value={summary.profit}
              label="Lucro Bruto"
            />
          </Col>
        </Row>

        <Loadable loading={loading}>
          <Paper elevation={1}>
            <DataTable
              manual
              defaultSorted={[
                {
                  id: order.field,
                  desc: order.direction === "DESC"
                }
              ]}
              defaultSort
              filterable={false}
              resultSet={results}
              total={pagination.total}
              perPage={pagination.perPage}
              page={pagination.page}
              config={mode === "product" ? this.productConfig : this.saleConfig}
              onChange={({ field, value }) =>
                presenter.onOrderChange(field, value)
              }
              orderField={order.field}
              orderDirection={order.direction}
              onPageChange={page => presenter.onPageChange(page + 1)}
            />
          </Paper>
        </Loadable>

        {this.downloadButton()}
      </Page>
    );
  }
}

export default ProductSalesReportView;



// WEBPACK FOOTER //
// ./src/components/app/management/product-sales-report/view.jsx